import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useValidateMaxCountForCage } from 'src/api/main-component'

export const useMaxCountForCageValidation = (customerId?: EntityId) => {
  const { customerId: routeCustomerId } = useParams()
  const effectiveCustomerId = (customerId ?? routeCustomerId) as EntityId
  const { mutateAsync: validateMaxCountForCage } = useValidateMaxCountForCage(effectiveCustomerId)

  return useCallback(
    async (positionId: EntityId | null | undefined, mainComponentIds: EntityId[]): Promise<boolean> => {
      if (!effectiveCustomerId || !positionId || mainComponentIds.length === 0) return false
      try {
        const response = await validateMaxCountForCage({ positionId, mainComponentIds })
        return response.data?.isExceeded ?? false
      } catch {
        return false
      }
    },
    [effectiveCustomerId, validateMaxCountForCage],
  )
}
